export const SURVEY_MODEL_DATA = {
	surveyStore: undefined
};
